import React from 'react';
import { Button } from '@material-ui/core';
import { Card } from 'react-bootstrap';
import EditIcon from '@material-ui/icons/Edit';
import ConfigItem from './ConfigItem';

const ClientPortalConfig = ({ config, onEdit }) => {
    if (!config) return null;

    return (
        <Card className='p-4'>
            <div>
                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '24px'
                }}>
                    <h5 style={{ margin: 0 }}>Client Portal Configuration</h5>
                    <Button
                        variant="contained"
                        color="primary"
                        startIcon={<EditIcon />}
                        onClick={onEdit}
                    >
                        Edit Configuration
                    </Button>
                </div>

                {/* Logo Preview */}
                {config.base64Logo && (
                    <div style={{
                        marginBottom: '24px',
                        padding: '16px',
                        backgroundColor: 'var(--bg-canvas)',
                        borderRadius: '8px',
                        textAlign: 'center'
                    }}>
                        <label style={{
                            display: 'block',
                            marginBottom: '8px',
                            color: '#666',
                            fontSize: '0.875rem',
                            fontWeight: 500
                        }}>
                            Portal Logo
                        </label>
                        <img
                            src={config.base64Logo}
                            alt="Portal logo"
                            style={{
                                maxWidth: '200px',
                                maxHeight: '100px',
                                objectFit: 'contain'
                            }}
                        />
                    </div>
                )}

                {/* Configuration Details */}
                <div style={{
                    backgroundColor: 'var(--bg-canvas)',
                    borderRadius: '8px',
                    padding: '16px'
                }}>
                    <ConfigItem label="Client Name" value={config.clientName} />
                    <ConfigItem label="Client UUID" value={config.clientUuid} />
                    <ConfigItem label="Subdomain" value={config.subdomain} />
                    <ConfigItem label="Page Name" value={config.pageName} />
                    <ConfigItem label="Portal URL" value={config.url} />
                    <ConfigItem label="Home Page URL" value={config.homePageUrl} />
                    <ConfigItem label="Product Name" value={config.productName} />
                    <ConfigItem label="Terms of Service URL" value={config.termsOfServiceUrl} />
                    <ConfigItem label="Authorization Text" value={config.authorizationText} scrollable />                    <ConfigItem label="Demo Mode" value={config.demoMode} />
                    <ConfigItem label="Business and Legal Disclosures" value={config.businessAndLegalDisclosures} />
                    <ConfigItem label="Created At" value={config.createdAt} />
                </div>
            </div>
        </Card>
    );
};

export default ClientPortalConfig;